import theme from '@styles/theme';
export default {
  toolbarTab: {
    position: 'relative',
    margin: '10px 0',
    padding: '15px',
    width: '50vw',
    maxWidth: '800px',
    maxHeight: '80vh',
    background: '#0d0d14',
    borderRadius: '10px',
    border: '2px solid #2d313b',
    color: 'white',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    fontSize: theme.fontSizes.smallText,
    lineHeight: '140%',
    overflow: 'auto'
  },
  toolbarTabContent: {
    position: 'relative',
    maxHeight: '100%'
  },
  badges: {
    display: 'flex',
    flexFlow: 'row wrap'
  },
  badge: (withBottomMargin = true) => ({
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginLeft: '10px',
    padding: '0 5px',
    border: '1px solid white',
    fontSize: '12px',
    lineHeight: '140%',
    marginBottom: withBottomMargin ? '10px' : '0'
  }),
  badgeIcon: {
    paddingTop: '4px',
    marginRight: '5px'
  },
  miniHeading: {
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '10px'
  }
};